import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class EncryptionProviderService {
  private key = CryptoJS.enc.Latin1.parse('aar6tzij8o1snaar');
  private iv = CryptoJS.enc.Latin1.parse('0123456789ABCDEF');
  guidArray: any[] = [];

  constructor() { }

  encryptData(dataToEncrypt: string | CryptoJS.lib.WordArray) {
    const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, this.key, {
      iv: this.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }

  decryptData(dataToDecrypt: string | CryptoJS.lib.CipherParams) {
    const decrypted = CryptoJS.AES.decrypt(dataToDecrypt, this.key, {
      iv:
        this.iv,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  getGuid(endPoint: string) {

    let selectedArr: any;
    this.guidArray.forEach((v: any) => {
      if (v.key === endPoint) {
        selectedArr = v;
        return;
      }
    });
    return selectedArr.value;
  }

  setGuid(arr: any) {
    for (let i = 0; i < this.guidArray.length; i++) {
      if (this.guidArray[i].key === arr.key) {
        this.guidArray.splice(i, 1);
      }
    }
    this.guidArray.push(arr);
  }
}
